import RouteTemplate from 'ember-route-template'
import { BookLibraryStudentSharesTable } from 'teacher-ui-client/components/book-library/student-shares-table'

export default RouteTemplate(BookLibraryStudentSharesTable)
